import { Linking } from "react-native";
import { toast } from "sonner-native";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { captureException } from "@utils/captureException";
import { MUSIC_ACCESS_FLOW_COPY } from "@libs/shared-ui";
import Button from "../common/Button";

/**
 * Members-only music's button for a fan outside its club (LIS-1156): fans
 * join a club on its artist's Live Link (the fan club decision, Decision 3),
 * so it opens that page (`clubUrl`, which the API gives while the club is
 * open on a published page). With no page to send them to it says "Members
 * only", as the Live Link's own tile does, and does nothing.
 */
const JoinFanClub = ({
  accessId,
  clubUrl,
}: {
  accessId: string;
  clubUrl: string | null;
}) => {
  if (clubUrl === null) {
    return (
      <Button.Button
        disabled
        onPress={() => {}}
        sentryEventName="AccessDetail.MembersOnly"
        bg="whiteTranslucent20"
      >
        <LIcon colors={{ color: "#FFFFFF80" }} name="lock_locked" size={16} />
        <LText variant="Caption/C1/Medium" color="white">
          {MUSIC_ACCESS_FLOW_COPY.membersOnly}
        </LText>
      </Button.Button>
    );
  }
  const open = () =>
    Linking.openURL(clubUrl).catch((error: unknown) => {
      toast.error("We couldn't open the fan club. Please try again.");
      captureException(error, {
        channel: "error",
        area: "linking",
        operation: "open-fan-club",
        tags: { accessId },
        extra: { clubUrl },
      });
    });
  return (
    <Button.Button
      onPress={() => void open()}
      sentryEventName="AccessDetail.JoinFanClub"
    >
      <LIcon colors={{ color: "black" }} name="extlink" size={16} />
      <LText
        variant="Caption/C1/Medium"
        color="black"
        textAlign="center"
        numberOfLines={2}
        adjustsFontSizeToFit
      >
        {MUSIC_ACCESS_FLOW_COPY.joinFanClub}
      </LText>
    </Button.Button>
  );
};

export default JoinFanClub;
